import { render, staticRenderFns } from "./StripePaymentV3.vue?vue&type=template&id=13bbc200&scoped=true"
import script from "./StripePaymentV3.vue?vue&type=script&setup=true&lang=js"
export * from "./StripePaymentV3.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StripePaymentV3.vue?vue&type=style&index=0&id=13bbc200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bbc200",
  null
  
)

export default component.exports